import { Results as ReactifySearchResults, Stats, useResults, useSearch } from "@usereactify/search";
import React, { useState, useEffect, useRef } from "react";
import { ResultsError } from "../Results/ResultsError";
import { ShowAll } from "../ResultsMeta/ShowAll";
import { InstantSearchItem } from "./InstantSearchItem";
import { InstantSearchNoResults } from "./InstantSearchNoResults";
import { InstantSearchSkeleton } from "./InstantSearchSkeleton";

export const InstantSearchResults: React.FC = () => {
  const { searchTerm } = useSearch();
  const { resultStats } = useResults();
  const [showSkeleton, setShowSkeleton] = useState(true);
  const prevSearchTermRef = useRef<string | undefined>(undefined);
  const prevResultsCountRef = useRef<number | undefined>(undefined);

  // Show skeleton when searchTerm changes
  useEffect(() => {
    if (searchTerm !== prevSearchTermRef.current) {
      setShowSkeleton(true);
      prevSearchTermRef.current = searchTerm;
    }
  }, [searchTerm]);

  // Hide skeleton when results update (different count means new results arrived)
  useEffect(() => {
    const currentCount = resultStats?.numberOfResults;

    // Only hide if count changed (indicating new results) or we have valid results
    if (currentCount !== undefined && currentCount !== prevResultsCountRef.current) {
      prevResultsCountRef.current = currentCount;
      // Small delay for smooth transition
      const timer = setTimeout(() => {
        setShowSkeleton(false);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [resultStats?.numberOfResults]);

  return (
    <div className="container flex justify-center">
      <div className="grid results-sec">
        <div className="grid__item medium-up--one-whole">
          <div className="grid">
            <div className="grid__item medium-up--four-fifths">
              {!showSkeleton && resultStats?.numberOfResults && (
                <h2 className="h4 results-meta">
                  {`Showing ${resultStats?.displayedResults} of ${resultStats?.numberOfResults} results for '${searchTerm}'`}
                </h2>
              )}
            </div>
          </div>
          <div className="new-grid product-grid collection-grid instant-search-results" data-view="6-3">
            {showSkeleton && <InstantSearchSkeleton />}
            <div style={{ display: showSkeleton ? "none" : "contents" }}>
              <ReactifySearchResults
                listClassName={`grid grid-cols-6`}
                pageSize={6}
                renderNoResults={() => <InstantSearchNoResults />}
                renderLoading={() => <InstantSearchSkeleton />}
                renderError={(props) => <ResultsError {...props} />}
                renderResultCardProduct={(props) => (
                  <InstantSearchItem itemRef={props.itemRef} product={props.product} />
                )}
              />
            </div>
            {!showSkeleton && (
              <Stats
                render={(renderProps) => (
                  <div className="grid__item medium-up--one-whole text-center">
                    <ShowAll {...renderProps} />
                  </div>
                )}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
